import { ActivityState } from './types'

const initialState: ActivityState = {
  activity: null,
  isLoading: false
}

export default initialState
